var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7676 9.30709V1.46094",
    stroke: "white",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5371 4.23077L15.0608 1.70711C15.4513 1.31658 16.0845 1.31658 16.475 1.70711L18.9986 4.23077",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76923 4.23047H3C1.89543 4.23047 1 5.1259 1 6.23047V16.9997C1 18.1043 1.89543 18.9997 3 18.9997H13.7692C14.8738 18.9997 15.7692 18.1043 15.7692 16.9997V12.0766",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.4618L3.27809 11.1837C4.05914 10.4027 5.32547 10.4027 6.10652 11.1837L13.9231 19.0003",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8457 13.462L9.73918 12.5685C10.5202 11.7875 11.7866 11.7875 12.5676 12.5685L15.7688 15.7697",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadNew);
export default __webpack_public_path__ + "static/media/uploadNew.bde48f2048b7b004e462aeab188ba6df.svg";
export { ForwardRef as ReactComponent };